import type { UserRole } from "@/user/user";
import { isAdmin } from "@/user/utils";

const IMPERSONATION_CONTROL_EMAIL_ALLOWLIST = new Set(["wpoerschke@gmail.com"]);

export const canShowImpersonationControl = ({
  role,
  email,
  isImpersonating,
}: {
  role: UserRole | undefined;
  email: string | undefined;
  isImpersonating: boolean;
}) =>
  isAdmin(role) &&
  !isImpersonating &&
  (email?.endsWith("@volca.ai") ||
    IMPERSONATION_CONTROL_EMAIL_ALLOWLIST.has(email ?? ""));
